import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { APP_PATHS, PAGE_PATHS } from '../../../../../types';
import { defaultFilters } from '../../../../../views/Risk/risk.utils';

const defaultRiskFilters = defaultFilters('finding');

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/risk/')({
  validateSearch: zodValidator(withDefaults(schema.RISK, defaultRiskFilters)),
  search: {
    middlewares: [stripSearchParams(defaultRiskFilters)],
  },
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({
      app: APP_PATHS.VULNERABILITIES,
      path: PAGE_PATHS.RISK,
    });
    context.validatePermissions({ isAllowed, preload });
  },
});
